module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$store.state.user.scope && _vm.activeTab === 'weight') ? _c('weight-line-graph', {
    staticClass: "insetGraph",
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.scope && _vm.activeTab === 'waist-hip') ? _c('waist-hip-line-graph', {
    staticClass: "insetGraph",
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  }) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.scope) ? _c('mu-row', {
    staticClass: "content",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "30",
      "tablet": "50"
    }
  }, [(_vm.$store.state.user.settings) ? _c('weight-input', {
    staticClass: "card-spacing bottom",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "height": _vm.$store.state.user.settings.height,
      "weight": _vm.$store.state.user.settings.weight,
      "waist": _vm.$store.state.user.settings.waist
    }
  }) : _vm._e(), _vm._v(" "), _c('tracking-exporter', {
    attrs: {
      "type": "weight"
    }
  }), _vm._v(" "), _c('tracking-notifier', {
    attrs: {
      "userId": _vm.$store.state.user.scope.user_id
    }
  })], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "70",
      "tablet": "50"
    }
  }, [_c('mu-card', {
    staticClass: "tracking-data",
    staticStyle: {
      "margin-top": "24px"
    },
    attrs: {
      "id": "blood-glucose-data"
    }
  }, [_c('mu-tabs', {
    staticClass: "weight-tabs",
    attrs: {
      "value": _vm.activeTab
    },
    on: {
      "change": _vm.handleTabChange
    }
  }, [_c('mu-tab', {
    staticClass: "tabTitle",
    attrs: {
      "value": "weight",
      "title": "WEIGHT"
    }
  }), _vm._v(" "), _c('mu-tab', {
    staticClass: "tabTitle",
    attrs: {
      "value": "waist-hip",
      "title": "WAIST-HIP"
    }
  })], 1), _vm._v(" "), _c('mu-card-text', [_c('p', {
    staticClass: "tracking-subtext",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.trackingHelpText'))
    }
  })]), _vm._v(" "), (_vm.activeTab === 'weight') ? _c('div', [_c('mu-timeline', _vm._l((_vm.groupFilter(_vm.activeTab)), function(group, groupKey) {
    return _c('div', {
      key: 'group-filter-' + groupKey,
      staticStyle: {
        "margin-bottom": "16px"
      }
    }, [_vm._l((group), function(titleItem, titleIndex) {
      return (titleIndex === 0) ? _c('div', {
        key: 'group-inner-' + titleIndex,
        staticClass: "timelineSpacing"
      }, [_c('div', {
        staticClass: "bold timelineTitle groupedDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedDateFormat(titleItem.date_created))
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group), function(item, index) {
      return _c('div', {
        key: 'group-item-' + index,
        staticClass: "timelineSpacing",
        class: {
          notEditMode: !item.isEditMode
        }
      }, [_c('mu-timeline-item', {
        nativeOn: {
          "click": function($event) {
            return _vm.showItemControls(item)
          }
        }
      }, [_c('mu-icon', {
        class: _vm.decideWhetherLostOrGained(item),
        staticStyle: {
          "margin-left": "-4px"
        },
        attrs: {
          "slot": "icon",
          "value": _vm.determineIcon(item)
        },
        slot: "icon"
      }), _vm._v(" "), (item.image) ? _c('div', [(item.image) ? _c('img', {
        attrs: {
          "width": "50%",
          "src": item.image
        }
      }) : _vm._e()]) : _vm._e(), _vm._v(" "), (!item.isEditMode) ? _c('div', {
        class: {
          spacingBottom: item.isControlsVisible
        }
      }, [_c('mu-row', [_c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "trackingDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedItemDate(item.date_created))
        }
      }) : _vm._e()]), _vm._v(" "), _c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "reading"
      }, [(_vm.$store.state.user.settings.weight.measure === 'kg') ? _c('div', [(item.userDevice.userDeviceId !== 0) ? _c('span', [_c('img', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip.left",
          value: ('From device: ' + item.userDevice.nickname),
          expression: "'From device: ' +  item.userDevice.nickname",
          modifiers: {
            "left": true
          }
        }],
        staticStyle: {
          "position": "relative",
          "top": "2px",
          "margin-right": "8px"
        },
        attrs: {
          "width": "18",
          "src": item.userDevice.device.iconBlue
        }
      })]) : _vm._e(), _vm._v(" "), _c('span', {
        domProps: {
          "textContent": _vm._s(item.kg + ' kg')
        }
      })]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.weight.measure === 'lbs') ? _c('div', [(item.userDevice && item.userDevice.userDeviceId !== 0) ? _c('span', [_c('img', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip.left",
          value: ('From device: ' + item.userDevice.nickname),
          expression: "'From device: ' +  item.userDevice.nickname",
          modifiers: {
            "left": true
          }
        }],
        staticStyle: {
          "position": "relative",
          "top": "2px",
          "margin-right": "8px"
        },
        attrs: {
          "width": "18",
          "src": item.userDevice.device.iconBlue
        }
      })]) : _vm._e(), _vm._v(" "), _c('span', {
        domProps: {
          "textContent": _vm._s(item.lbs + ' lbs')
        }
      })]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.weight.measure === 'st-lbs') ? _c('div', [(item.userDevice.userDeviceId !== 0) ? _c('span', [_c('img', {
        directives: [{
          name: "tooltip",
          rawName: "v-tooltip.left",
          value: ('From device: ' + item.userDevice.nickname),
          expression: "'From device: ' +  item.userDevice.nickname",
          modifiers: {
            "left": true
          }
        }],
        staticStyle: {
          "position": "relative",
          "top": "2px",
          "margin-right": "8px"
        },
        attrs: {
          "width": "18",
          "src": item.userDevice.device.iconBlue
        }
      })]) : _vm._e(), _vm._v(" "), _c('span', {
        domProps: {
          "textContent": _vm._s(item.stones + 'st ' + item.pounds + ' lbs')
        }
      })]) : _vm._e()]) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), (item.isControlsVisible === true && !item.isEditMode) ? _c('div', [_c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.editText'),
          "icon": "edit"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.editReading(item)
          }
        }
      }), _vm._v(" "), _c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.deleteText'),
          "icon": "delete"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.deleteReading(item)
          }
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.isEditMode) ? _c('div', [_c('weight-edit', {
        attrs: {
          "preference": _vm.$store.state.user.settings.weight.measure,
          "item": item
        },
        on: {
          "updateReading": _vm.updateReading,
          "closeEditPanel": function($event) {
            return _vm.closeEditMode(item)
          }
        }
      })], 1) : _vm._e()], 1)], 1)
    })], 2)
  }), 0), _vm._v(" "), (_vm.isReadingsLoading) ? _c('mu-card-text', {
    attrs: {
      "align": " center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "color": "#0179d5"
    }
  }), _vm._v(" "), _c('div', [_vm._v("One sec...")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isReadingsLoading) ? _c('div', {
    ref: "detector"
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'waist-hip') ? _c('div', [(!_vm.isReadingsLoading) ? _c('mu-timeline', _vm._l((_vm.groupFilter(_vm.activeTab)), function(group, groupKey) {
    return _c('div', {
      key: 'group-filter-' + groupKey,
      staticStyle: {
        "margin-bottom": "16px"
      }
    }, [_vm._l((group), function(titleItem, titleIndex) {
      return (titleIndex === 0) ? _c('div', {
        key: 'group-inner-' + titleIndex,
        staticClass: "timelineSpacing"
      }, [_c('div', {
        staticClass: "bold timelineTitle groupedDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedDateFormat(titleItem.date_created))
        }
      })]) : _vm._e()
    }), _vm._v(" "), _vm._l((group), function(item, index) {
      return _c('div', {
        key: 'group-item-' + index,
        staticClass: "timelineSpacing",
        class: {
          notEditMode: !item.isEditMode
        }
      }, [_c('mu-timeline-item', {
        nativeOn: {
          "click": function($event) {
            return _vm.showItemControlsWaistHip(item)
          }
        }
      }, [_c('mu-icon', {
        class: _vm.determineLostOrGainedWaistHip(item),
        staticStyle: {
          "margin-left": "-4px"
        },
        attrs: {
          "slot": "icon",
          "value": _vm.determineIcon(item)
        },
        slot: "icon"
      }), _vm._v(" "), (item.image) ? _c('div', [(item.image) ? _c('img', {
        attrs: {
          "width": "50%",
          "src": item.image
        }
      }) : _vm._e()]) : _vm._e(), _vm._v(" "), (!item.isEditMode) ? _c('div', {
        class: {
          spacingBottom: item.isControlsVisible
        }
      }, [_c('mu-row', [_c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "trackingDate",
        domProps: {
          "textContent": _vm._s(_vm.groupedItemDate(item.date_created))
        }
      }) : _vm._e()]), _vm._v(" "), _c('mu-col', [(!item.isEditMode) ? _c('div', {
        staticClass: "reading",
        staticStyle: {
          "text-align": "right"
        }
      }, [(_vm.$store.state.user.settings.waist.measure === 'cm') ? _c('div', [(typeof(item.ratio_cm) === 'number') ? _c('span', {
        domProps: {
          "textContent": _vm._s(item.ratio_cm.toFixed(2))
        }
      }) : _vm._e(), _vm._v(" "), _c('span', {
        staticStyle: {
          "display": "block"
        },
        domProps: {
          "textContent": _vm._s('(' + item.waist_cm + 'cm/' + item.hip_cm + 'cm)')
        }
      })]) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.settings.waist.measure === 'in') ? _c('div', [(typeof(item.ratio_in) === 'number') ? _c('span', {
        domProps: {
          "textContent": _vm._s(item.ratio_in.toFixed(2))
        }
      }) : _vm._e(), _vm._v(" "), _c('span', {
        staticStyle: {
          "display": "block"
        },
        domProps: {
          "textContent": _vm._s('(' + item.waist_in + 'in/' + item.hip_in + 'in)')
        }
      })]) : _vm._e()]) : _vm._e()])], 1)], 1) : _vm._e(), _vm._v(" "), (item.isControlsVisible === true && !item.isEditMode) ? _c('div', [_c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.editText'),
          "icon": "edit"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.editReadingWaistHip(item)
          }
        }
      }), _vm._v(" "), _c('mu-flat-button', {
        attrs: {
          "color": _vm.btnColor,
          "label": _vm.$t('message.deleteText'),
          "icon": "delete"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.deleteWaistHipReading(item)
          }
        }
      })], 1) : _vm._e(), _vm._v(" "), (item.isEditMode) ? _c('div', [_c('waist-hip-edit', {
        attrs: {
          "preference": _vm.$store.state.user.settings.waist.measure,
          "item": item
        },
        on: {
          "updateReading": _vm.updateWaistHipReading,
          "closeEditPanel": function($event) {
            return _vm.closeEditModeWaistHip(item)
          }
        }
      })], 1) : _vm._e()], 1)], 1)
    })], 2)
  }), 0) : _vm._e(), _vm._v(" "), (_vm.isReadingsLoading) ? _c('mu-card-text', {
    attrs: {
      "align": " center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "color": "#0179d5"
    }
  }), _vm._v(" "), _c('div', [_vm._v("One sec...")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isReadingsLoading) ? _c('div', {
    ref: "detector"
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c7a0590","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Tracking/Weight.vue
// module id = 3594
// module chunks = 1